import { render, staticRenderFns } from "./approval-status-label.vue?vue&type=template&id=e421a22a&"
import script from "./approval-status-label.vue?vue&type=script&lang=ts&"
export * from "./approval-status-label.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports